










import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import { TaskType, CommentType, CustomerType } from '../../types'
import { TimeStamp } from '../../firebase/init'

@Component({
  components: {
  },
})
export default class SingleComment extends Mixins(MainMixin) {
  @Prop() data!:CommentType

  get avatar() {
    return `https://firebasestorage.googleapis.com/v0/b/canvas-forms-profiles/o/profiles%2F${this.data.user || ''}_70x70.png?alt=media` || 'http://placehold.it/70x70'
  }

  get username() {
    return this.getUserName(this.data.user)
  }

  get createdAt() {
    if (!this.data || !this.data.created) return 'Unknown Date'
    return this.relativeTime(this.data.created.toDate())
  }
}

